<mat-toolbar id="mat_toolbar" color="primary" class="mat-elevation-z2">
  <mat-toolbar-row>
    <button mat-icon-button>
      <mat-icon *ngIf="authService.isLoggedIn" (click)="clickMenu()"
                [class]="sidenavToggle ? 'burger_menu_icon rotate' : 'burger_menu_icon'">
        {{sidenavToggle ? 'menu_open' : 'menu' }}</mat-icon>
    </button>
    <h1 routerLink="vorhersagen/computer-mos/uebersicht" class="toolbar_title" *ngIf="screenService.hasLargeScreen()">
      Kundenwebsite</h1>
    <span class="menu_spacer"></span>
    <div class="toolbar_options_container">
      <button [matTooltip]="bundeslandFilterService.getSelectedBundesLaenderNamen().join(',')"
              class="toolbar_icon_button" mat-icon-button>
        <mat-icon matBadge="{{bundeslandFilterService.getSelectedBundesLaender().length}}" matBadgeColor="accent"
                  matBadgeOverlap="true"
                  *ngIf="authService.isLoggedIn" (click)="openFilterDialog()">filter_alt
        </mat-icon>
      </button>
      <button (click)="toggleBreadcrumbs()" mat-icon-button>
        <mat-icon [style]="breadcrumbToggle ? 'color: #ffa500' : ''">double_arrow</mat-icon>
      </button>
      <app-user-menu></app-user-menu>
    </div>
  </mat-toolbar-row>
</mat-toolbar>

